import { setup } from "xstate";

export enum MentalWellbeingState {
  Dashboard = "dashboard",
  MentalWellbeingScreen = "mentalWellbeingScreen",
  Questionnaire = "questionnaire",
}

export const mentalWellbeingEventNames = {
  OPEN_SCREEN: "OPEN_SCREEN",
  BACK: "BACK",
  OPEN_QUESTIONNAIRE: "OPEN_QUESTIONNAIRE",
  BACK_TO_SCREEN: "BACK_TO_SCREEN",
};

export const mentalWellbeingMachine = setup({
  types: {} as { context: Record<string, never> },
}).createMachine({
  id: "mentalWellbeing",
  initial: MentalWellbeingState.Dashboard,
  context: {},
  states: {
    [MentalWellbeingState.Dashboard]: {
      on: {
        [mentalWellbeingEventNames.OPEN_SCREEN]: {
          target: MentalWellbeingState.MentalWellbeingScreen,
        },
        [mentalWellbeingEventNames.OPEN_QUESTIONNAIRE]: {
          target: MentalWellbeingState.Questionnaire,
        },
      },
    },
    [MentalWellbeingState.MentalWellbeingScreen]: {
      on: {
        [mentalWellbeingEventNames.BACK]: {
          target: MentalWellbeingState.Dashboard,
        },
        [mentalWellbeingEventNames.OPEN_QUESTIONNAIRE]: {
          target: MentalWellbeingState.Questionnaire,
        },
      },
    },
    [MentalWellbeingState.Questionnaire]: {
      on: {
        [mentalWellbeingEventNames.BACK_TO_SCREEN]: {
          target: MentalWellbeingState.MentalWellbeingScreen,
        },
      },
    },
  },
});
